import styles from './ProjectFilterModal.module.scss';
import { STAGE_TYPE_FILTER_CATEGORIES } from './ProjectsFilterModal.constants';
import StageTypeFilterRow from './StageTypeFilterRow';

const StagesTabContent = () => (
  <>
    <p className={styles.stageTypeHint}>Roles must match every row</p>
    <div className={styles.stageTypeRows}>
      {STAGE_TYPE_FILTER_CATEGORIES.map(category => (
        <StageTypeFilterRow category={category} key={category} />
      ))}
    </div>
  </>
);

export default StagesTabContent;
